import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import ReactMarkdown from 'react-markdown';
import { FaFacebookSquare, FaTwitterSquare } from 'react-icons/lib/fa';

import PersonForm from 'components/PersonForm';
import PostForm from 'components/PostForm';
import Post from 'components/Post';

export class Person extends Component {
  state = { isEditing: false };

  render() {
    const { person, refetchQueries, onEdit } = this.props;
    const { name, info, posts, fb, twitter } = person;
    const { isEditing } = this.state;

    return (
      <div>
        {/* <pre>{JSON.stringify(person, null, 2)}</pre> */}
        {!isEditing && (
          <div>
            <h1>
              {name}
              <button
                className="btn btn-outline-secondary float-right"
                onClick={() => this.setState({ isEditing: true })}
              >
                edit
              </button>
            </h1>

            <div className="card" style={{ marginBottom: 30 }}>
              <div className="card-body">
                <p className="card-text">
                  <ReactMarkdown source={info} />
                </p>
                {fb && (
                  <a href={fb} className="card-link">
                    <FaFacebookSquare />
                    {fb}
                  </a>
                )}
                {twitter && (
                  <a
                    href={`https://twitter.com/${twitter}`}
                    className="card-link"
                  >
                    <FaTwitterSquare />
                    twitter
                  </a>
                )}
              </div>
            </div>
          </div>
        )}

        {isEditing && (
          <PersonForm
            person={person}
            onSave={() => this.setState({ isEditing: false })}
          />
        )}

        <PostForm person_id={person.id} refetchQueries={refetchQueries} />
        <div style={{ height: 30 }} />
        {posts.map(post => <Post post={post} key={post.id} />)}
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
// Person.propTypes = {};

export default Person;



// WEBPACK FOOTER //
// ./src/components/Person.js